<template>
  <div class="main">
    <c-action-sheet :visible.sync="visibleInline">
      <p class="divider">
        <span class="divider-inner-text">分享到</span>
      </p>
      <ul class="box">
        <li class="item" @click="shareTo(enumObj.wechat)">
          <img src="http://res.laoban100.com/app-comm/assets/images/mallview/FrbIDqzdMGkMpGJpwq5HNGjuRNwM.png" alt="">
          <span>微信</span>
        </li>
        <li class="item" @click="shareTo(enumObj.wechatTimeline)">
          <img src="http://res.laoban100.com/app-comm/assets/images/mallview/FkhslI14-_hVzE4bamXuOQMUa7xW.png" alt="">
          <span>朋友圈</span>
        </li>
        <li class="item clip-btn" :data-clipboard-text="href">
          <img src="http://res.laoban100.com/app-comm/assets/images/mallview/FkPpOwWCI1MFNixljOYfvneTqECA.jpg" alt="">
          <span>复制链接</span>
        </li>
      </ul>
    </c-action-sheet>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  name: 'ShareWeChat',
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const enumObj = {
      wechat: 'wechat', // 微信分享
      wechatTimeline: 'circleFriends' // 微信朋友圈
    }
    return {
      enumObj,
      visibleInline: false,
      href: ''
    }
  },
  created () {
    this.visibleInline = this.visible
    this.href = window.location.href
    new Clipboard('.clip-btn').on('success', () => {
      this.$wejs.toast('复制成功')
    })
  },
  methods: {
    shareTo (shareType) {
      window.$fe_bridge.shareAction[shareType](this.config, function () {
        window._hmt && window._hmt.push(['_trackEvent', 'ShareAction', 'share', this.userInfo])
        window._hmt && window._hmt.push(['_trackEvent', 'ShareAction', 'shareType', this.config])
      })
      setTimeout(() => {
        this.close()
      }, 330)
    },
    close () {
      this.visibleInline = false
    }
  },
  computed: {
    userInfo: {
      get () {
        return this.$store.getters[`userInfo/getUserInfo`]
      }
    }
  },
  watch: {
    visibleInline (val) {
      this.$emit('update:visible', val)
    },
    visible (val) {
      this.visibleInline = val
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../assets/scss/base/_mixin";
  .divider {
    display: table;
    margin: 16px 0;
    color: rgba(0,0,0,0.85);
    font-weight: 500;
    font-size: 16px;
    white-space: nowrap;
    text-align: center;
    background: transparent;
    &::after, &::before {
      position: relative;
      top: 50%;
      display: table-cell;
      width: 50%;
      border-top: 1px solid #e8e8e8;
      -webkit-transform: translateY(50%);
      -ms-transform: translateY(50%);
      transform: translateY(50%);
      content: '';
    }
    
    &-inner-text {
      display: inline-block;
      padding: 0 24px;
    }
  }
  .box {
    display: flex;
    padding: px2rem(30px) 8%;
    .item {
      flex: 0 0 33%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
     img {
       display: inline-block;
       width: px2rem(100px);
       height: px2rem(100px);
       margin-bottom: px2rem(15px)
     }
      span {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// share.vue?21e36d36